import React from "react";
import { Avatar, Dropdown } from "antd";
import { withTranslation } from "react-i18next";

import themes from "../../../utils/themes";
import { getOptimizedImage, getOptimizedAvatar } from "../../../utils/images";

import styled from "styled-components/macro";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 12px;

  .avatar {
    img {
      object-fit: cover;
    }
    cursor: pointer;
    border: 1px solid transparent;
    transition: 0.15s ease border-color;
    &.ant-dropdown-open {
      border-color: ${({ theme }) => theme["@primary"]};
    }
  }

  .custom-logo {
    height: 64px !important;
    width: 200px !important;
    cursor: pointer;
  }
`;

const Profile = ({ t, image, email, menu }) => {
  const customTheme = themes[email] || {};
  return (
    <Container data-test="profile">
      <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
        {customTheme.img ? (
          <img
            data-test="avatar"
            className="custom-logo"
            src={getOptimizedImage(customTheme.img)}
            alt={t("global:logo")}
          />
        ) : (
          <Avatar
            data-test="avatar"
            className="avatar"
            size="large"
            src={getOptimizedAvatar(image)}
            icon="user"
          />
        )}
      </Dropdown>
    </Container>
  );
};

export default withTranslation(["global"])(Profile);
